export default "__VITE_ASSET__DLGdbDIR__"